/* eslint-disable no-duplicate-imports */
import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import InnerHTML from 'dangerously-set-html-content';

type BazzarvoiceTransactionPixelProps = {
    order: SalesOrder;
    locale: string;
};

const BazzarvoiceTransactionPixel = ({ order, locale }: BazzarvoiceTransactionPixelProps) => {
    const bvLocale = (locale || 'en-CA').replace('-', '_');

    const items = order.SalesLines?.map(sl => {
        return {
            name: sl.Description || sl.ItemId || '',
            price: `${sl.TotalAmount || 0}`,
            quantity: `${sl.Quantity || 1}`,
            productId: sl.ItemId || '',
            discount: `${sl.DiscountAmount || 0}`
        };
    });

    const bvArgs = {
        orderId: order.ChannelReferenceId || '',
        currency: order.CurrencyCode || 'CAD',
        total: `${order.TotalAmount || 0}`,
        tax: `${order.TaxAmount || 0}`,
        shipping: `${order.ShippingChargeAmount || 0}`,
        discount: `${order.DiscountAmount || 0}`,
        items,
        email: order.ReceiptEmail,
        locale: bvLocale,
        nickname: order.Name || ''
    };

    const scriptContent = `window.bvCallback = function(BV) {BV.pixel.trackTransaction(${JSON.stringify(bvArgs)});};`;
    const scriptTag = `<script id="hei-bv-order-confirmation">${scriptContent}</script>`;

    return <InnerHTML html={scriptTag} />;
};

export { BazzarvoiceTransactionPixel };
